import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./index.css";

import App from "./App";
import { ThemeColorModeProvider } from "./common/contexts/GlobalContext";
import MainPage from "./pages/main";
import EditTabComponent from "./Tags/components/EditTabComponent";
import Error404Page from "./pages/Error404Page";
import Error500Page from "./pages/Error500Page";
import ErrorElement from "./common/helpers/ErrorElement";
import InitialRedirect from "./common/components/InitialRedirect";
import CodeLegendLandingPage from "./CodeLegends/components/CodeLegendLandingPage";
import Unauthorized from "./pages/Unauthorized";
import UniversalDescriptorManagerLandingPage from "./UniversalDescriptors/components/UniversalDescriptorManagerLandingPage";
import BulkTagMappingLandingPage from "./BulkTagMapping/components/BulkTagMappingLandingPage";

/*
* Conceptually, for reference, the app is set up like this:
<App />                   // Global providers, ErrorBoundary
 └── <Outlet />           // Routed to:
     └── <MainPage />     // Contains AppBar, Drawer (essntially a layout/design wrapper)
         └── <Outlet />   // Renders /edit, /apps, etc. content
*/

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorElement />,
    children: [
      {
        element: <MainPage />,
        children: [
          {
            index: true,
            element: <InitialRedirect />,
          },
          {
            path: "tags/:assetIds?",
            element: <EditTabComponent />,
          },
          {
            path: "codelegends",
            element: <CodeLegendLandingPage />,
          },
          {
            path: "universalDescriptors",
            element: <UniversalDescriptorManagerLandingPage />,
          },
          {
            path: "bulkTagMapping",
            element: <BulkTagMappingLandingPage />,
          },
          {
            path: "404",
            element: <Error404Page />,
          },
          {
            path: "500",
            element: <Error500Page />,
          },
        ],
      },
    ],
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeColorModeProvider>
      <RouterProvider router={router} />
    </ThemeColorModeProvider>
  </React.StrictMode>
);
